import React from "react";
import { Row, Col } from "react-bootstrap";
import Page from "../common/page/Page";
import useTranslationAuthenticationUi from "./useTranslationAuthenticationUi";
import useShowLoader from "../common/loading-widgets/useShowLoader";
import ConnectionModeSignUp from "./ConnectionModeSignUp";


export default function ConnectionModeSignUpPage() {
  const { t, loading: tLoading } = useTranslationAuthenticationUi();
  useShowLoader(tLoading, "ConnectionModeSignUpPage");
  if (tLoading) return null;

  return (
    <div className="ConnectionModeSignUpPage">
      <Page>
        <Page.Title
          text={t("authentication-ui:registration_method")}
          loading={tLoading}
        />
        <Page.Content>
          <Row>
            <Col>
              <ConnectionModeSignUp/>
            </Col>
          </Row>
        </Page.Content>
      </Page>
    </div>
  );
}
